"use strict";

import { Collection } from "Collection";
import { FormDetailsModel } from 'Models/FormDetailsModel';
import { Objects } from "Constants/objects";
export var FormDetailsCollection = Collection.extend({
  model: FormDetailsModel,
  object: Objects.SysSubForms
});